var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("van-nav-bar", {
        attrs: {
          "safe-area-inset-top": "",
          "left-arrow": "",
          "right-text": _vm.txt,
          title: "消息通知",
          "z-index": "10",
          fixed: "",
        },
        on: { "click-left": _vm.onClickLeft, "click-right": _vm.onClickRight },
      }),
      _c(
        "div",
        { staticClass: "tabs-box-style" },
        [
          _c(
            "van-tabs",
            {
              on: {
                click: function ($event) {
                  return _vm.onClick(_vm.active)
                },
              },
              model: {
                value: _vm.active,
                callback: function ($$v) {
                  _vm.active = $$v
                },
                expression: "active",
              },
            },
            [
              _c(
                "van-tab",
                { attrs: { title: "我的消息" } },
                [
                  _c(
                    "van-list",
                    {
                      attrs: {
                        finished: _vm.finishedMy,
                        "finished-text": "没有更多了",
                      },
                      on: { load: _vm.onLoadMy },
                      model: {
                        value: _vm.loadingMy,
                        callback: function ($$v) {
                          _vm.loadingMy = $$v
                        },
                        expression: "loadingMy",
                      },
                    },
                    _vm._l(_vm.listMy, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "div-box-style",
                          on: {
                            click: function ($event) {
                              return _vm.orderClick(item)
                            },
                          },
                        },
                        [
                          _c(
                            "van-row",
                            [
                              _c("van-col", { attrs: { span: "1" } }),
                              _c(
                                "van-col",
                                {
                                  staticClass: "col-box-style",
                                  attrs: { span: "16" },
                                },
                                [
                                  item.isRead === "0"
                                    ? _c("div", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.circle,
                                            expression: "circle",
                                          },
                                        ],
                                        staticClass: "circle-style",
                                      })
                                    : _vm._e(),
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "10px" } },
                                    [_vm._v(_vm._s(item.msgTitle))]
                                  ),
                                ]
                              ),
                              _c("van-col", { attrs: { span: "6" } }, [
                                _c("span", [_vm._v(_vm._s(item.sendTimeStr))]),
                              ]),
                              _c("van-col", { attrs: { span: "1" } }),
                            ],
                            1
                          ),
                          _c(
                            "van-row",
                            { staticStyle: { "margin-top": "8px" } },
                            [
                              _c(
                                "van-col",
                                {
                                  staticClass: "col-box-style",
                                  attrs: { span: "22" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-left": "20px",
                                        color: "#909090",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.msgContent) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("van-col", { attrs: { span: "1" } }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "van-tab",
                { attrs: { title: "系统公告" } },
                _vm._l(_vm.announcementArr, function (item, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: true,
                          expression: "true",
                        },
                      ],
                      key: index,
                      staticClass: "div-box-style",
                    },
                    [
                      _c(
                        "van-row",
                        [
                          _c("van-col", { attrs: { span: "1" } }),
                          _c(
                            "van-col",
                            {
                              staticClass: "col-box-style",
                              attrs: { span: "16" },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "10px" } },
                                [_vm._v(_vm._s(item.noticeTitle))]
                              ),
                            ]
                          ),
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("span", [
                              _vm._v(_vm._s(item.noticeReleaseTimeStr)),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "1" } }),
                        ],
                        1
                      ),
                      _c(
                        "van-row",
                        { staticStyle: { "margin-top": "8px" } },
                        [
                          _c(
                            "van-col",
                            {
                              staticClass: "col-box-style",
                              attrs: { span: "22" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "20px",
                                    color: "#909090",
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.noticeContent) + " ")]
                              ),
                            ]
                          ),
                          _c("van-col", { attrs: { span: "1" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }